<template>
  <div class="container" id="home" v-if="isLoggedIn">
    <div class="row">
      <!-- Productos -->
      <div class="col">
        <div class="card">
          <img src="img/productos.svg" class="card-img-top" alt="..." />
          <div class="card-body">
            <router-link
              class="btn btn-primary btn-block"
              :to="{ name: 'Dashboard' }"
            >
              Ver Productos
            </router-link>
          </div>
        </div>
      </div>
      <!-- Productos Publicados -->
      <div class="col">
        <div class="card">
          <img
            src="img/sucursales.svg"
            class="card-img-top"
            alt="Clientes"
            style="padding:0 1rem"
          />
          <div class="card-body">
            <router-link
              class="btn btn-primary btn-block"
              :to="{ name: 'productosPublicados' }"
            >
              Productos Publicados
            </router-link>
          </div>
        </div>
      </div>
      <!-- Pedidos -->
      <div class="col">
        <div class="card">
          <img
            src="img/pedidos.svg"
            class="card-img-top"
            alt="..."
            style="padding:0 1rem"
          />
          <div class="card-body">
            <router-link
              class="btn btn-primary btn-block"
              :to="{ name: 'Pedidos' }"
            >
              Pedidos
            </router-link>
          </div>
        </div>
      </div>
      <!-- Clientes -->
      <div class="col">
        <div class="card">
          <img
            src="img/motocicleta_cruvi.svg"
            class="card-img-top"
            alt="..."
            style="padding:0 1rem"
          />
          <div class="card-body">
            <router-link
              class="btn btn-primary btn-block"
              :to="{ name: 'Repartidores' }"
            >
              Repartidores
            </router-link>
          </div>
        </div>
      </div>
      <!-- Documentación -->
      <div class="col">
        <div class="card">
          <img
            src="img/documents.svg"
            class="card-img-top"
            alt="Clientes"
            style="padding:0 1rem"
          />
          <div class="card-body">
            <router-link
              class="btn btn-primary btn-block"
              :to="{ name: 'verDocumentos' }"
            >
              Ver Documentos
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <!-- Row -->
    <div class="row">
      <!-- Documentación -->
      <div class="col-2">
        <div class="card">
          <img
            src="img/documents.svg"
            class="card-img-top"
            alt="Clientes"
            style="padding:0 1rem"
          />
          <div class="card-body">
            <router-link
              class="btn btn-primary btn-block"
              :to="{ name: 'verDocumentos' }"
            >
              Ver Documentos
            </router-link>
          </div>
        </div>
      </div>
      <!-- col -->
      <!-- Clientes -->
      <div class="col-2">
        <div class="card">
          <img
            src="img/clientes.svg"
            class="card-img-top"
            alt="Clientes"
            style="padding:0 1rem"
          />
          <div class="card-body">
            <a href="#" class="btn btn-primary btn-block">
              Ver Clientes
            </a>
          </div>
        </div>
      </div>
      <!-- clientes -->
    </div>
  </div>
  <div class="container" id="home-login" v-else @click="logout">
    <h1 class="text-center">Es necesario que inicies sesi&oacute;n</h1>
    <hr />
    <h5 class="text-center">Serás redireccionado en {{ segundos }} segundos</h5>
  </div>
</template>

<style>
#home .card img {
  opacity: 0.4;
}
#home .card:hover img {
  opacity: 1;
}
</style>

<script>
export default {
  name: "Home",
  data: () => {
    return {
      segundos: 10
    };
  },
  /* created() {
    console.log(this.$store.state.token);
  },*/
  mounted() {
    this.decrementarReloj();
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.token != null;
    }
  },
  methods: {
    decrementarReloj() {
      if (this.segundos <= 0) {
        return this.logout();
      }
      setTimeout(() => {
        this.segundos--;
        this.decrementarReloj();
      }, 1000);
    },
    logout() {
      if (this.segundos < 0) {
        return;
      }
      this.segundos = 0;
      let linkLogin = document.getElementById("login-link");
      if (linkLogin) {
        linkLogin.click();
      }
    }
  }
};
</script>
